import * as r from 'ramda';
import { resolve } from './util';

export default ({ optionality, erc20Contract, serviceFactory, log }) => {

  var update = () => {};
  var pairs = [];

  optionality.deployed()
    .then(opty => {
      opty.PairRegistered({}, { fromBlock: 0, toBlock: 'latest' }).watch((err, event) => {
        if (err) {
          log.error(err);
        } else {
          log.handle('updating-pair', async () => {
            const targetContract = await erc20Contract.at(event.args.target);
            const currencyContract = await erc20Contract.at(event.args.currency);
            const target = await resolve(targetContract, ['symbol', 'decimals', 'address']);
            const currency = await resolve(currencyContract, ['symbol', 'decimals', 'address'])
            const pair = {
              name: target.symbol + " - " + currency.symbol,
              target,
              currency,
              decimals: target.decimals
            };
            pairs = r.sortBy(r.prop('name'), [...pairs, pair]);
            update({ pairs })
          })
        }
      })
      opty.PairUnregistered({}, { fromBlock: 0, toBlock: 'latest' }).watch((err, log) => {
        if (err) {
          log.error(err);
        } else {
          pairs = r.filter(pair => pair.target !== log.args.target || pair.currency !== log.args.currency, pairs)
          update({ pairs });
        }
      })
    });

  return serviceFactory({
    name: 'pair-service',
    subscribe: (_update) => {
      update = _update;
      update({ pairs });
      return () => {
        update = () => {}
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/pairs-service.js